
import {Component, Prop, Vue} from "vue-property-decorator";
import {
  currentUserModule,
  studyPatientContext,
} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import {formatDate, formatDateTime} from "@/auxillary/date-format";
import {translate} from "@/auxillary/translation";
import ReferenceRedirectLine from "@/components/query/overview/ReferenceRedirectLine.vue";
import QueryOverviewTableAnswer from "@/components/query/overview/QueryOverviewTableAnswer.vue";
import QueryStateIcon from "@/components/query/icons/QueryStateIcon.vue";
import IQueryOverviewShortDto = MdbsCore.IQueryOverviewShortDto;
import QueryShortDto = MdbsCore.QueryShortDto;
import {QueryStage} from "@/components/query/QueryStates";

@Component({
  name: 'PatientQueries',
  components: {QueryStateIcon, ReferenceRedirectLine, QueryOverviewTableAnswer},
  filters: {
    formatDate,
    formatDateTime,
    translate,
    formatNullable: function (value?: any | undefined): string {
      return value ?? "-";
    }
  }
})
export default class PatientQueries extends Vue {

  @Prop({default: ""}) private patientId: string;
  @Prop({default: ""}) private queries: Array<QueryShortDto>;

  queriesTotal = 0;

  get patient() {
    return studyPatientContext.studyPatient;
  }

  get filteredQueries() {
    const queries = [...this.queries];
    const sortedQueries = queries
        .sort((x, y) => ((x?.creationDate ? x.creationDate.getTime() : 0) - (y?.creationDate ? y.creationDate.getTime() : 0)));

    // five or less queries
    /*if (sortedQueries.length <= 5)
      return sortedQueries
          .sort((x, y) => StringCompare(x.queryTypeDefinitionType ?? "", y.queryTypeDefinitionType ?? ""));*/

    const sortedSmQueries = sortedQueries
        .filter(query => query.queryTypeDefinitionType == "SMQuery" && !!query.lastComment &&
            (query.lastComment.creatingUserRoleIdentifier == "Physician" || query.lastComment.creatingUserRoleIdentifier == "Nurse"));
    const sortedDmQueries = sortedQueries
        .filter(query => query.queryTypeDefinitionType == "DMQuery" && !!query.lastComment &&
            (query.lastComment.creatingUserRoleIdentifier == "Physician" || query.lastComment.creatingUserRoleIdentifier == "Nurse"));

    // first sm, then dm. over 5 sm, then only sm.
    if (this.userRoleIdentifier == "Physician" || this.userRoleIdentifier == "Nurse") {
      const smQueries = sortedQueries.filter(query => query.queryTypeDefinitionType == "SMQuery");
      const dmQueries = sortedQueries.filter(query => query.queryTypeDefinitionType == "DMQuery");
      //if (smQueries.length >= 5)
      //  return smQueries;

      const addedList = smQueries.concat(dmQueries);
      return addedList;
    }

    // if less than 5 sm, return with dm
    if (this.userRoleIdentifier == "SafetyManager") {
      //if (sortedSmQueries.length >= 5)
      //  return sortedSmQueries;

      const addedList = sortedSmQueries.concat(sortedDmQueries);
      return addedList;
    }

    // if less than 5 dm, return with sm
    if (this.userRoleIdentifier == "DataManager") {
      //if (sortedDmQueries.length >= 5)
      //  return sortedDmQueries;

      const addedList = sortedDmQueries.concat(sortedSmQueries);
      return addedList;
    }

    return queries
        .sort((x, y) =>
            ((x?.creationDate ? x.creationDate.getTime() : 0) - (y?.creationDate ? y.creationDate.getTime() : 0)));
  }

  get filteredSlicedQueries() {
    if (this.filteredQueries.length > 5)
      return this.filteredQueries.slice(0,5);
    return this.filteredQueries;
  }

  get hasFilteredQueries() {
    return this.filteredQueries.length > 0;
  }

  get hasMoreOpenQueries() {
    return this.moreOpenQueriesCount > 0;
  }

  get moreOpenQueriesCount() {
    if (this.filteredQueries.length <=5)
      return 0;

    const additionalQueries = this.filteredQueries.slice(5, this.filteredQueries.length);
    const additionalOpenQueries = additionalQueries.filter(query => query.stageState == QueryStage.OPEN);
    return additionalOpenQueries.length;
  }

  get openQueriesText() {
    if (!this.hasFilteredQueries)
      return "Es liegen keine relevanten Queries vor.";
    let queryRoleType = this.moreOpenQueriesCount == 1? "offener" : "offene";
    if (this.userRoleIdentifier == "SafetyManager" || this.userRoleIdentifier == "DataManager")
      queryRoleType = this.moreOpenQueriesCount == 1? "beantworteter" : "beantwortete";

    if (this.moreOpenQueriesCount == 1)
      return "Es liegt noch 1 weiterer " + queryRoleType + " Query vor.";
    if (this.moreOpenQueriesCount > 1)
      return "Es liegen noch " + this.moreOpenQueriesCount + " weitere " + queryRoleType + " Queries vor.";
    return "";
  }

  get queryHtmlText() {
    return (query: IQueryOverviewShortDto) => {
      let text = query.text;
      if (query.instrumentDisplayKey != undefined)
        text = text + "<br/>" + translate(query.instrumentDisplayKey)
      if (query.visitDisplayKey != undefined)
        text = text + "<br/>" + translate(query.visitDisplayKey)
      return text;
    }
  }

  get userRoleIdentifier() {
    return currentUserModule.roleIdentifier;
  }

  async mounted() {
    /*const result = await queryModule.loadQueryOverview({
      page: 1,
      itemsPerPage: 5,
      sortBy: [],
      sortDesc: [],
      studyPatientId: this.patientId,
      studyInstituteId: undefined
    });
    this.queries = result.items ?? [];
    this.queriesTotal = result.itemsTotal ?? 0;*/
  }

  async openQueryOverview() {
    await this.$router.push({
      name: "query-overview"
    })
  }
}
